import { ExpandableJsonPanel } from '#components/ExpandableJsonPanel'
import { createErrorMappingIssueUrl } from '#utils/github'

interface ErrorsSectionProps {
  errors: any[]
  errorType?: string
  carrier?: string
  requestId: string
  externalId: string
  service: 'documents' | 'ebol' | 'tender' | 'rating' | 'tracking'
}

const ErrorsSection = ({
  errors,
  errorType,
  carrier,
  requestId,
  externalId,
  service,
}: ErrorsSectionProps) => {
  if (!Array.isArray(errors) || errors.length === 0) {
    return null
  }

  return (
    <div className="rounded-box bg-red-500/10 border border-red-500/30 p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-red-400" />
          <h3 className="text-lg font-bold text-red-300">Errors</h3>
        </div>
        <a
          href={createErrorMappingIssueUrl({
            carrier: carrier || 'unknown',
            errorType: errorType || 'N/A',
            requestId,
            externalId,
            errors,
            service,
          })}
          target="_blank"
          rel="noopener noreferrer"
          className="px-3 py-1.5 text-sm font-medium text-red-200 bg-red-900/30 hover:bg-red-900/50 border border-red-500/30 hover:border-red-500/50 rounded-lg transition-colors"
        >
          Create GitHub Issue
        </a>
      </div>

      <div className="space-y-2">
        {errors.map((error: any, index: number) => (
          <div
            key={index}
            className="rounded-lg bg-slate-950/50 border border-red-500/20 p-3"
          >
            {typeof error === 'string' ? (
              <p className="text-sm text-red-200">{error}</p>
            ) : error.message ? (
              <p className="text-sm text-red-200">
                {error.message}
                {error.rawMessage && (
                  <>
                    <br />
                    <span className="text-xs">Raw - {error.rawMessage}</span>
                  </>
                )}
              </p>
            ) : (
              <ExpandableJsonPanel
                title=""
                data={error}
                maxHeight="max-h-48"
                preClassName="bg-slate-950/80 border border-red-500/20 font-mono text-red-100"
              />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export { ErrorsSection }
